import Swiper from "swiper";

export default function HeaderFixed(container) {
  const header = container;
  const pageMain = document.querySelector(".main");
  const fixedClass = "is-fixed";
  const openMenuClass = "is-open-menu";
  const headerSlider = container.querySelector(".js-header-slider-container");
  const openMenuBtn = container.querySelector(".js-open-mobile-menu");
  const closeMenuBtn = container.querySelector(".js-close-mobile-menu");
  let windowWidth = document.body.clientWidth;
  let desctop = false;
  let slider;
  // let sliderContainer;
  // let sliderOptions;

  if (windowWidth > 1200) {
    desctop = true;
  }

  // console.log("desctopStart", desctop, headerSlider);

  const sliderContainer = headerSlider;

  const nextButtonElement = document.getElementsByClassName(
    "js-header-slider-arrow-next"
  )[0];
  const previousButtonElement = document.getElementsByClassName(
    "js-header-slider-arrow-prev"
  )[0];

  const sliderOptions = {
    init: false,
    slideClass: "js-header-slider-slide",
    wrapperClass: "js-header-slider-wrapper",
    slidesPerView: "auto",
    // observer: true,
    // observeParents: true,
    loop: true,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: previousButtonElement
    }
  };

  if (desctop) {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }

  openMenuBtn.addEventListener("click", function openMenu() {
    header.classList.add(openMenuClass);
    document.body.style.overflow = "hidden";
  });

  closeMenuBtn.addEventListener("click", function closeMenu() {
    header.classList.remove(openMenuClass);
    document.body.style.overflow = "auto";
  });

  window.addEventListener("scroll", function fixedHeader() {
    const scrolledY = window.pageYOffset || document.documentElement.scrollTop;

    if (scrolledY >= 240 && desctop) {
      if (!header.classList.contains(fixedClass)) {
        header.classList.add(fixedClass);
        pageMain.classList.add(fixedClass);
      }
    } else if (header.classList.contains(fixedClass)) {
      header.classList.remove(fixedClass);
      pageMain.classList.remove(fixedClass);
    }
  });

  window.addEventListener("resize", function resizeWidth() {
    windowWidth = document.body.clientWidth;

    if (windowWidth > 1200) {
      desctop = true;
    } else {
      desctop = false;
    }

    resizeSlider(desctop);

    window.addEventListener("scroll", function fixedHeader() {
      const scrolledY =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrolledY >= 240 && desctop) {
        if (!header.classList.contains(fixedClass)) {
          header.classList.add(fixedClass);
          pageMain.classList.add(fixedClass);
        }
      } else if (header.classList.contains(fixedClass)) {
        header.classList.remove(fixedClass);
        pageMain.classList.remove(fixedClass);
      }
    });

    function resizeSlider(isDesctop) {
      if (isDesctop) {
        // console.log("", slider, !slider || slider.destroyed);

        if (!slider || slider.destroyed) {
          slider = new Swiper(sliderContainer, sliderOptions);
          slider.init();
        }
        if (header.classList.contains(openMenuClass)) {
          header.classList.remove(openMenuClass);
          document.body.style.overflow = "auto";
        }
      } else if (slider) {
        slider.destroy(true, true);
      }
    }

    // console.log("desctop", desctop, headerSlider);
  });
}
